import HomeResources from "@/components/marketing/HomeResources";
// FieldlinkNZ public homepage — composed from reusable marketing components.
// All copy/pricing/features live in @/data/marketing.js (single source of truth).
import { SEO } from "@/lib/seo";
import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { Hero, Workflow, ScrollStory, IndustryTiles, FeatureSplit, ProductCapabilities, CustomerProof, IntegrationStrip, Pricing, FAQ, FinalCTA } from "@/components/marketing/WebsiteSections";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import { PLANS } from "@/data/marketing";

// Previous homepage design, kept at a hidden backup link when `archived`.
export default function Landing({ archived = false }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Fieldlink NZ",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, Android, iOS",
    description: "Civil construction management software for NZ contractors — takeoffs, quoting, jobs, crews, plant, safety, job costing and invoicing in one platform.",
    offers: PLANS.map((p) => ({
      "@type": "Offer", name: `Fieldlink ${p.name}`, price: p.price, priceCurrency: "NZD",
      url: "https://www.fieldlink.co.nz/register",
    })),
  };
  return (
    <div className="web-site" data-testid={archived ? "landing-classic" : "landing-page"}>
      <SEO
        title="Civil Construction Software NZ | Fieldlink"
        description="From takeoff and quoting to crews, plant, safety, job costing and invoicing — Fieldlink connects the office and field without the paperwork. Built in NZ for civil contractors. 7-day free trial."
        path={archived ? undefined : "/"}
        jsonLd={archived ? undefined : jsonLd}
        noindex={archived}
      />
      <a className="web-skip" href="#main-content">Skip to content</a>
      <MarketingHeader classic={archived} />
      <main id="main-content">
        <Hero />
        <Workflow />
        <HomeResources />
        <ScrollStory />
        <IndustryTiles />
        <FeatureSplit />
        <ProductCapabilities />
        <CustomerProof />
        <IntegrationStrip />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <MarketingFooter />
    </div>
  );
}
